import { defineMessages } from "@/i18n";
import en from "./en";

export const uiMessages = defineMessages("ui", en);
